import type { UserEventData } from '@moniebook-web/utils';
import { type AppDatabase } from '../db';

export class MixpanelService {
    constructor(private readonly db: AppDatabase) {
        this.db = db;
    }

    async insert(event: UserEventData) {
        await this.db.mixpanelEvents.put(event);
    }

    async getAll() {
        const events = await this.db.mixpanelEvents.toArray();

        return events;
    }

    async removeAll() {
        await this.db.mixpanelEvents.clear();
    }
}
